import type { GooglePlugin } from '@shared/analytics/types/google'
import {
  onErrorReturnEvent,
  onOrderReturnEvent,
  onSaveQrCodeReturnEvent,
  onSaveReturnLabelEvent,
  onShowQrCodeReturnEvent,
  onStartReturnEvent,
  removeErrorReturnEvent,
  removeOrderReturnEvent,
  removeSaveQrCodeReturnEvent,
  removeSaveReturnLabelEvent,
  removeShowQrCodeReturnEvent,
  removeStartReturnEvent,
} from '@shared/event/events/return'

const initReturnEvents = (Analytics: GooglePlugin) => {
  const startReturnEventToken = onStartReturnEvent(() => {
    Analytics.event({
      event: 'returns_tracking',
      returns_action: 'return start',
      product_sku: '',
      item_name: '',
      item_variant: '',
      returns_country: '',
    })
  })

  const errorReturnEventToken = onErrorReturnEvent(({ error }) => {
    Analytics.event({
      event: 'returns_tracking',
      returns_action: 'error',
      returns_label: error,
      product_sku: '',
      item_name: '',
      item_variant: '',
      returns_country: '',
    })
  })

  const orderReturnEventToken = onOrderReturnEvent(
    ({ order, selectedProducts, selectedAddress }) => {
      for (const { sku, reason } of selectedProducts) {
        const item = order.items.find((item) => item.variant.sku === sku)

        Analytics.event({
          event: 'returns_tracking',
          returns_action: 'return product',
          product_sku: sku,
          item_name: item?.variant.product?.attributes.modelUntranslated || '',
          item_variant:
            item?.variant.product?.attributes.styleUntranslated || '',
          returns_label: reason,
          returns_country: order?.[selectedAddress]?.iso2Code,
        })
      }
    }
  )

  const showQrCodeEventToken = onShowQrCodeReturnEvent(
    ({ order, addressType }) => {
      Analytics.event({
        event: 'returns_tracking',
        returns_action: 'returns download',
        returns_label: 'show qr code',
        product_sku: '',
        item_name: '',
        item_variant: '',
        returns_country: order?.[addressType]?.iso2Code,
      })
    }
  )

  const saveQrCodeEventToken = onSaveQrCodeReturnEvent(
    ({ order, addressType }) => {
      Analytics.event({
        event: 'returns_tracking',
        returns_action: 'returns download',
        returns_label: 'save qr code',
        product_sku: '',
        item_name: '',
        item_variant: '',
        returns_country: order?.[addressType]?.iso2Code,
      })
    }
  )

  const saveReturnLabelToken = onSaveReturnLabelEvent(
    ({ order, addressType }) => {
      Analytics.event({
        event: 'returns_tracking',
        returns_action: 'returns download',
        returns_label: 'download pdf label',
        product_sku: '',
        item_name: '',
        item_variant: '',
        returns_country: order?.[addressType]?.iso2Code,
      })
    }
  )

  return () => {
    removeStartReturnEvent(startReturnEventToken)
    removeErrorReturnEvent(errorReturnEventToken)
    removeOrderReturnEvent(orderReturnEventToken)
    removeShowQrCodeReturnEvent(showQrCodeEventToken)
    removeSaveQrCodeReturnEvent(saveQrCodeEventToken)
    removeSaveReturnLabelEvent(saveReturnLabelToken)
  }
}

export default initReturnEvents
